import { render } from "./DivSettings.vue?vue&type=template&id=74653a13&scoped=true"
import script from "./DivSettings.vue?vue&type=script&lang=js"
export * from "./DivSettings.vue?vue&type=script&lang=js"

import "./DivSettings.vue?vue&type=style&index=0&id=74653a13&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74653a13"]])

export default __exports__